import Conivera1 from '../Conifera/Conifera (1).webp'
import Conivera2 from '../Conifera/Conifera (2).webp'
import Conivera3 from '../Conifera/Conifera (3).webp'
import Conivera4 from '../Conifera/Conifera (4).webp'
import Conivera5 from '../Conifera/Conifera (5).webp'


const Coniveraimages =[
Conivera1,Conivera2,Conivera3,Conivera4,Conivera5                   
]

export default Coniveraimages;